import { styled, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { CartonIcon } from "@packsize/components";

const Root = styled("div")`
	height: 100%;
	padding-top: 10vh;

	display: flex;
	align-items: center;
	flex-direction: column;
	row-gap: 16px;
`;

export const EmptyOrdersView = () => (
	<Root>
		<CartonIcon sx={{ fontSize: 72 }} />

		<Typography variant="h5">
			<FormattedMessage id="No orders created yet" defaultMessage="No orders created yet" />
		</Typography>
	</Root>
);
